import styled from 'styled-components'
import { Icon } from '@navent-jobs/ui-kit/components/icon'
import { Link } from '@navent-jobs/ui-kit/components/link'

export const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const WrapperAutopostulado = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.extra.ultraLighten};
  border-radius: 8px;
  margin-top: 30px;
`

export const IconCustom = styled(Icon)`
  ${({ marginRight }) => marginRight && `margin-right: ${marginRight}`}
`

export const ButtonEstadisticas = styled(Link)`
  display: flex;
  direction: row;
  align-items: center;
  padding: 8px;
  width: max-content;

  border: 1px solid ${({ theme }) => theme.colors.primary.normal};

  &:hover,
  &:focus:not(:active) {
    border: 1px solid ${({ theme }) => theme.colors.primary.normal};
  }

  @media (min-width: ${({ theme }) => theme.screen.lgMin}) {
    margin-bottom: 8px;
  }
`

export const LabelButtonEstadisticas = styled('p')`
  line-height: 16px;
  margin: 0;
  padding: 0px 12px 0px 8px;
`

export const WordingContainer = styled('div')`
  padding: ${({ hasPreguntasPendientes }) => (hasPreguntasPendientes ? '15px 0 16px 0' : '21px 0')};
  display: flex;
  justify-content: center;
  align-items: center;

  @media (min-width: ${({ theme }) => theme.screen.lgMin}) {
    ${({ hasPreguntasPendientes }) => !hasPreguntasPendientes && 'padding: 60px 0px'};
  }
`

export const ImageContainer = styled.div`
  position: absolute;
  top: -28px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 50%;
  background: linear-gradient(
    0deg,
    ${({ theme }) => theme.colors.grey0} -14.47%,
    ${({ theme }) => theme.colors.extra.lighten} 221.71%
  );
  width: 56px;
  height: 56px;
  text-align: center;
  overflow: hidden;
  justify-self: center;
  align-content: center;
  z-index: 2;
`

export const AutopostulacionContainer = styled.div`
  padding: 6px;
  width: 100%;
  position: relative;
  min-height: 56px;
`

export const AutopostulacionImage = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 7px;
`

export const PostuladoContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin-bottom: 24px;
  text-align: left;

  & > *:first-child {
    flex-shrink: 0;
    margin-top: 2px;
  }

  & > *:last-child {
    white-space: normal;
    word-break: break-word;
  }

  @media (min-width: 363px) and (max-width: 1023px), (min-width: 1075px) {
    text-align: center;
    align-items: center;

    & > *:first-child {
      margin-top: 0px;
    }
  }

  @media (min-width: 1024px) and (max-width: 1074px) {
    text-align: left;
    align-items: flex-start;

    & > *:first-child {
      margin-top: 2px;
    }
  }
`
